export const environment = {
    appName: 'Event Checkin',
    serviceHostName: 'https://api-dev-hilldistrictgrandstand.txlivestockshows.com'
};